import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import IconButton from '@alltrails/denali/components/IconButton';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import Close from '@alltrails/denali/icons/Close';
import PageUISectionList from '@alltrails/layout/components/PageUI/PageUISectionList/PageUISectionList';
import type { PageUI } from '@alltrails/layout/utils/PageUI/pageUI';
import PageUIMapHoverProvider from '@alltrails/maps/components/PageUIMapHoverProvider/PageUIMapHoverProvider';
import { useSidebar } from '@alltrails/maps/components/Sidebar/useSidebar';
import usePageUITrailResults from '@alltrails/maps/hooks/usePageUITrailResults';
import { useAppDispatch } from '@/utils/redux';
import { exitAsk } from '@/utils/slices/askSlice';
import styles from './AskSidebar.module.scss';

type Props = {
  /** The response to show. Without one the panel shows its greeting. */
  page?: PageUI;
};

const AskSidebar = ({ page }: Props) => {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobileSizedScreen();

  usePageUITrailResults(page);

  const title = 'Ask AllTrails'; // hwandrew TODO: XPLR-204 translations
  const closeLabel = 'Close Ask AllTrails'; // hwandrew TODO: XPLR-204 translations
  const greeting = "Hi! Tell me what you're looking for and I'll help you find the right trail."; // hwandrew TODO: XPLR-204 translations

  const closeButton = <IconButton icon={{ Component: Close }} onClick={() => dispatch(exitAsk())} size="sm" title={closeLabel} />;

  const { SidebarHeader, SidebarContent } = useSidebar({ additionalButton: closeButton, collapseBehavior: 'none', fullHeight: true });

  const body = (
    <PageUIMapHoverProvider>
      <div className={styles.transcript}>
        {page ? (
          <PageUISectionList page={page} />
        ) : (
          <Typography component="p" variant="text200">
            {greeting}
          </Typography>
        )}
      </div>
    </PageUIMapHoverProvider>
  );

  if (isMobile) {
    return (
      <div className={styles.mobileContainer}>
        <div className={styles.mobileHeader}>
          <Heading as="h2" size="300">
            {title}
          </Heading>
          {closeButton}
        </div>
        <div className={styles.mobileBody}>{body}</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {SidebarHeader(title)}
      {SidebarContent(body)}
    </div>
  );
};

export default AskSidebar;
